module.exports = {
  localeName: 'ko-KR',
  momentFormat: 'YYYY/MM/DD',
};
